// theme.js
export const lightTheme = {
  body: "#FFF",
  text: "#363537",
  logoColor: "rgb(85, 26, 139)",
  progressBackground: "#f3efef",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  subTitle: "#848c94",
  subTitleHover: "#6b737b",
  buttonBackground: "#55198b",
  buttonBorder: "#55198b",
  buttonHoverBackGround: "#fff",
  buttonHoverColor: "black",
  menuItemHoverBackground: "#f4f4f4",
  scrollMenuItemBackground: "#191c4d",
  scrollMenuItemHoverBackground: "#1f2260",
  cardBackground: "rgb(255, 255, 255, 0.9)",
  cardShadow: "rgba(0, 0, 0, 0.2) 0px 10px 30px -15px",
  cardHoverShadow: "rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;",
}

export const darkTheme = {
  body: "#0a192f",
  text: "#f4f4f4",
  progressBackground: "#f3efef",
  gradient: "linear-gradient(#091236, #1E215D)",
  subTitle: "#bbc1c3",
  subTitleHover: "#6b737b",
  logoColor: "#bbbfc4",
  buttonBackground: "transparent",
  buttonBorder: "#55198b",
  buttonHoverBackGround: "#172a45",
  menuItemHoverBackground: "#172a45",
  scrollMenuItemBackground: "#191c4d",
  scrollMenuItemHoverBackground: "#1f2260",
  cardBackground: "#0a192f",
  cardShadow: "#172a45 0px 20px 30px -10px",
  cardHoverShadow: "hsl(211, 10%, 60%) 0px 10px 30px -15px;",
}
